import { noop } from 'lodash'
import { createStore } from 'zustand'

import {
  RIGHT_PANEL_TAB_KEY_VARIABLE_CONFIGURE,
  RIGHT_PANEL_TAB_KEY_VARIABLE_LIST
} from '../../RightPanel/constants'

import { ContractDesignerStore } from './interface'

export const createContractDesingerStore = () =>
  createStore<ContractDesignerStore>((set, get) => ({
    formData: {},
    formLoading: false,
    formError: undefined,
    setInitialFormData(formData) {
      if (!formData.id) {
        set({ formData })
      }
    },
    updateFormData(formData) {
      set({ formData })
    },
    setTemplateName: name => {
      set(state => ({ formData: { ...state.formData, name } }))
    },
    setTemplateContent: content => {
      set(state => ({ formData: { ...state.formData, content } }))
    },
    setTemplateEnable: enable => {
      set(state => ({ formData: { ...state.formData, enable } }))
    },
    templateVariableData: [],
    templateVariableLoading: false,
    templateVariableError: undefined,
    refreshTemplateVariableData: noop,
    hasTemplateVariable(templateVariableId) {
      return get().templateVariableData.some(
        variable => variable.id === templateVariableId
      )
    },
    usedNodeKeys: new Set(),
    addUsedNodeKeys(...nodeKeys) {
      set(state => {
        const usedNodeKeys = new Set(state.usedNodeKeys)
        nodeKeys.forEach(nodeKey => usedNodeKeys.add(nodeKey))
        return { usedNodeKeys }
      })
    },
    removeUsedNodeKeys(...nodeKeys) {
      set(state => {
        const usedNodeKeys = new Set(state.usedNodeKeys)
        nodeKeys.forEach(nodeKey => usedNodeKeys.delete(nodeKey))
        return { usedNodeKeys }
      })
    },
    activedVariableNodeKey: undefined,
    setActivedVariableNodeKey(nodeKey) {
      set({
        activedVariableNodeKey: nodeKey,
        // 点击变量节点时，默认打开变量配置面板
        rightPanelActiveKey: nodeKey
          ? RIGHT_PANEL_TAB_KEY_VARIABLE_CONFIGURE
          : RIGHT_PANEL_TAB_KEY_VARIABLE_LIST
      })
    },
    rightPanelActiveKey: RIGHT_PANEL_TAB_KEY_VARIABLE_LIST,
    setRightPanelActiveKey(activeKey) {
      set({ rightPanelActiveKey: activeKey })
    }
  }))
